export default __webpack_public_path__ + "static/media/search.ccf2c008.svg";